/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable, Injector, Type } from '@angular/core';
import { ToolbarOptions } from './toolbar-options';

export interface SidebarOptions {
  title: string;
  component: Type<any>;
  injector?: Injector;
}

export abstract class RootLayout {
  abstract setToolbarOptions(options: ToolbarOptions): void;

  abstract resetToolbarOptions(): void;

  abstract showSidebar(options: SidebarOptions): void;

  abstract hideSidebar(): void;
}

@Injectable()
export class DelegatedRootLayout extends RootLayout {
  private layout: RootLayout;

  setup(layout: RootLayout): void {
    if (this.layout) {
      throw new Error('DelegatedRootLayout: layout is already set');
    }
    this.layout = layout;
  }

  hideSidebar(): void {
    this.layout.hideSidebar();
  }

  resetToolbarOptions(): void {
    this.layout.resetToolbarOptions();
  }

  setToolbarOptions(options: ToolbarOptions): void {
    this.layout.setToolbarOptions(options);
  }

  showSidebar(options: SidebarOptions): void {
    this.layout.showSidebar(options);
  }
}
